import React from 'react'
import './dots.css'

const Dots = () => {

      return (
            <div className="dots_content flex">
                  <span></span>
                  <span></span>
                  <span></span>
            </div>
      )
}

export default Dots
